import React, { useEffect, useState } from 'react';
import { trackPixel, trackAndNavigate } from '../utils/pixel';
type Plan = 'megapack' | 'megapack-gestion' | 'megapack-pro';
export function Pricing() {
  useEffect(() => {
    const section = document.getElementById('pricing');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackPixel('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'Megapack Estimulación Temprana'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const [selected, setSelected] = useState<Plan>('megapack-pro');
  const cartUrls: Record<Plan, string> = {
    megapack: 'https://checkout.construyeprogreso.com/cart/48185772966058:1',
    'megapack-gestion': 'https://checkout.construyeprogreso.com/cart/48185777684650:1',
    'megapack-pro': 'https://www.bibliotecaprofesional.com/cart/48369090134186:1'
  };
  const plans: Record<Plan, {
    emoji: string;
    name: string;
    desc: string;
    priceOld: string;
    priceNew: string;
    priceColor: string;
    cta: string;
    sub: string;
    badge?: string;
    badgeColor?: string;
  }> = {
    megapack: {
      emoji: '👶',
      name: 'MEGAPACK BASE',
      desc: '6 tomos + 6 bonos · 0 a 36 meses completo',
      priceOld: '$58.990',
      priceNew: '$19.990',
      priceColor: 'text-gray-900',
      cta: '→ SÍ, QUIERO EL MEGAPACK BASE',
      sub: '6 tomos · 6 bonos · Acceso inmediato'
    },
    'megapack-gestion': {
      emoji: '📋',
      name: 'MEGAPACK GESTIÓN COMPLETA',
      desc: 'Todo el Base + 6 Planillas Clínicas listas para tu consultorio.',
      priceOld: '$79.990',
      priceNew: '$27.990',
      priceColor: 'text-gray-900',
      cta: '→ SÍ, QUIERO EL MEGAPACK GESTIÓN COMPLETA',
      sub: '6 tomos · 6 bonos · 6 Planillas Clínicas · Acceso inmediato',
      badge: '⭐ OFERTA 2',
      badgeColor: 'bg-gray-700'
    },
    'megapack-pro': {
      emoji: '🏆',
      name: 'MEGAPACK CONSULTORIO PROFESIONAL',
      desc: 'Todo el Gestión Completa + Gabinete Visual + Método Integral™.',
      priceOld: '$102.990',
      priceNew: '$32.990',
      priceColor: 'text-cyan-brand',
      cta: '→ SÍ, QUIERO EL MEGAPACK CONSULTORIO PROFESIONAL',
      sub: '6 tomos · 6 bonos · Planillas · Gabinete Visual · Método Integral™ · Acceso inmediato',
      badge: '🏆 MÁS ELEGIDO',
      badgeColor: 'bg-cyan-brand'
    }
  };
  const active = plans[selected];
  return <section id="pricing" className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(240,249,255) 0%, rgb(240,249,255) 15%, rgb(248,250,252) 85%, rgb(236,254,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-191">
      <div className="mx-auto max-w-3xl" data-id="element-192">
        {/* Heading */}
        <div className="text-center mb-8" data-id="element-193">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-wide text-cyan-brand border border-cyan-brand/40 bg-cyan-brand/5 rounded-full px-4 py-1.5 mb-4" data-id="element-194">
            🔥 Precio de lanzamiento — Sube sin previo aviso
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-195">
            Elegí tu <span className="text-cyan-brand" data-id="element-196">Megapack:</span>
          </h2>
          <p className="text-xs text-gray-500 m-0" data-id="element-197">
            Las tres opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        {/* Plan Selector */}
        <div className="flex flex-col gap-3 mb-6" data-id="element-198">
          {(Object.keys(plans) as Plan[]).map(plan => {
          const p = plans[plan];
          const isSelected = selected === plan;
          const isPro = plan === 'megapack-pro';
          return <button key={plan} onClick={() => setSelected(plan)} className="w-full text-left rounded-xl p-4 transition-all cursor-pointer" style={{
            backgroundColor: isSelected ? 'rgb(240,249,255)' : 'rgb(255,255,255)',
            border: isPro ? isSelected ? '2px solid rgb(0,180,216)' : '2px solid rgba(0,180,216,0.4)' : isSelected ? '2px solid rgb(0,180,216)' : '1px solid rgb(229,231,235)',
            boxShadow: isSelected ? 'rgba(0,180,216,0.15) 0px 0px 30px 0px' : isPro ? 'rgba(0,180,216,0.08) 0px 4px 16px 0px' : undefined
          }} data-id="element-199">
                <div className="flex items-center gap-3" data-id="element-200">
                  {/* Radio */}
                  <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2" style={{
                borderColor: isSelected ? 'rgb(0,180,216)' : 'rgb(209,213,219)'
              }} data-id="element-201">
                    {isSelected && <div className="h-2.5 w-2.5 rounded-full" style={{
                  backgroundColor: 'rgb(0,180,216)'
                }} data-id="element-202" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-203">
                    <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-204">
                      <span data-id="element-205">{p.emoji}</span>
                      <span className="text-sm font-black text-gray-900" data-id="element-206">
                        {p.name}
                      </span>
                      {p.badge && <span className={`${p.badgeColor} text-[10px] font-black text-white rounded-full px-2 py-0.5`} data-id="element-207">
                          {p.badge}
                        </span>}
                    </div>
                    <p className="text-xs text-gray-500 m-0" data-id="element-208">{p.desc}</p>
                  </div>

                  {/* Price */}
                  <div className="shrink-0 text-right" data-id="element-209">
                    <div className="text-xs text-gray-400 line-through" data-id="element-210">
                      {p.priceOld}
                    </div>
                    <div className={`text-2xl font-black ${p.priceColor}`} data-id="element-211">
                      {p.priceNew}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Block */}
        <div className="rounded-2xl p-5 shadow-lg" style={{
        background: 'linear-gradient(135deg, rgb(0,180,216), rgb(0,150,199))'
      }} data-id="element-212">
          {/* What you get summary */}
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mb-4" data-id="element-213">
            {active.sub.split(' · ').map(item => <span key={item} className="text-[11px] font-bold text-white/90 flex items-center gap-1" data-id="element-214">
                <span className="text-white/60" data-id="element-215">✓</span> {item}
              </span>)}
          </div>

          {/* Main CTA */}
          <a href={cartUrls[selected]} onClick={e => {
          e.preventDefault();
          trackAndNavigate('InitiateCheckout', {
            content_name: selected === 'megapack-pro' ? 'Megapack Consultorio Profesional' : selected === 'megapack-gestion' ? 'Megapack Gestión Completa' : 'Megapack Base',
            content_category: 'Estimulación Temprana',
            value: selected === 'megapack-pro' ? 32990 : selected === 'megapack-gestion' ? 27990 : 19990,
            currency: 'ARS'
          }, cartUrls[selected]);
        }} className="block w-full bg-white text-cyan-brand text-center text-sm sm:text-base font-black rounded-xl py-4 no-underline hover:bg-cyan-50 transition-colors" data-id="element-216">
            {active.cta}
          </a>

          {/* Subline */}
          <p className="text-center text-[11px] text-white/70 mt-3 mb-0" data-id="element-217">
            Más de 500 profesionales ya planifican con criterio y cobran lo que
            merecen
          </p>
        </div>

        {/* Trust Badges */}
        <div className="mt-4 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500 bg-white rounded-xl px-4 py-3 shadow-sm border border-gray-100" data-id="element-218">
          <span data-id="element-219">🔒 Pago seguro</span>
          <span data-id="element-220">⚡ Acceso en 5 min</span>
          <span data-id="element-221">🛡️ Garantía 7 días</span>
          <span data-id="element-222">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}